package com.downdogapp.client

data class YearMonth(val year: Int, val month: Int) {

  val numDaysInMonth
    get() =
      CalendarHelper.numDaysInMonth(this)

  val monthNameShort
    get() =
      CalendarHelper.monthNameShort(this)

  val monthYearNameLong
    get() =
      CalendarHelper.monthYearNameLong(this)

  fun previousMonth() =
    if (month == 0)
      YearMonth(year - 1, 11)
    else
      YearMonth(year, month - 1)

  fun nextMonth() =
    if (month == 11)
      YearMonth(year + 1, 0)
    else
      YearMonth(year, month + 1)
}
